import { useEffect, useState } from 'react';
import { CurrentJournals } from '../components/CurrentJournals';
import { Loading } from '../components/Loading';
import '../stylesheets/HomePage.css';
import axios from '../axios';

export function HomePage() {
  const [currentJournals, setCurrentJournals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadingData();
  }, [])

  async function loadingData() {
    const response = await axios.get('journals/last-three');
    setCurrentJournals(response.data);
    setLoading(false);
  }

  return (
    <div className='HomePage'>
      <div className='content'>
        <h1>Բարի գալուստ</h1>
        <p><b>Սիրելի՛ ընթերցողներ.</b></p>
        <p>Բացելով էլեկտրոնային այս կայքը` նպատակ ունենք թերթի միջոցով նպաստել Հայաստանում և Հայաստանից դուրս` արտասահմանում գտնվող մեր հավատացյալ եղբայրների ու քույրերի, ընդհանրապես հայ ժողովրդի հոգևոր շինությանը: Մենք գիտենք, որ արտասահմանում գտնվող յուրաքանչյուր հայ կարիք ունի իմանալու և մեծ հետաքրքրասիրությամբ ուզում է իմանալ Հայաստանի ԱՀՔ եկեղեցում տեղի ունեցող անցուդարձի մասին: Մենք տպագրում ենք «Բարի լուր» թերթը և անվճար ուղարկում Հայաստանից դուրս` Ռուսաստան, Եվրոպա, Ամերիկա: Սիրելի' ընթերցողներ, խնդրում ենք աղոթել թերթի համար, որպեսզի այն ծառայի մեր ժողովրդի ապաշխարությանն ու հոգևոր արթնությանը:</p>
      </div>

      {loading && <Loading />}

      <CurrentJournals currentJournals={currentJournals} />
    </div>
  )
}
